/*
 * Re Login
 * @Author: lipan
 * @Date:   2016-01-18 11:29:29
 * @Last Modified by:   lipan
 * @Last Modified time: 2016-01-20 12:11:07
 */
import Vue from 'vue'
import ReLogin from './re-login.vue'

export default {
    open() {
        let reLoginWrapper = document.querySelector('.sets-re-login')
        if (!reLoginWrapper) {
            reLoginWrapper = document.createElement('div')
            reLoginWrapper.className = 'sets-re-login'
            document.body.appendChild(reLoginWrapper)
        }
        const div = document.createElement('div')
        div.innerHTML = `<re-login @close="close"></re-login>`
        reLoginWrapper.appendChild(div)
        const reLogin = new Vue({
            el: reLoginWrapper,
            components: {ReLogin},
            methods: {
                close() {
                    reLoginWrapper.removeChild(div)
                }
            }
        }).$children[0]
        reLogin.$emit('show')
    }
}


// WEBPACK FOOTER //
// ./bootsets/components/re-login/index.js